import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export function isSortDirection(value: string): value is SortDirection {
  return (Object.values(SortDirection) as string[]).includes(value);
}

export interface TableSort<T extends string = string> {
  direction: SortDirection;
  key: T;
}

export const SortDirectionSchema = createEnum(SortDirection, {
  enumName: "SortDirection",
});

export function createTableSortSchema<T extends z.ZodString | z.ZodEnum<any>>(
  keySchema: T,
) {
  return z.object({ direction: SortDirectionSchema, key: keySchema });
}

export const PaginationCursorSchema = z.object({
  nextToken: z.string(),
  previousToken: z.string(),
  page: z.number(),
});
export type PaginationCursor = z.infer<typeof PaginationCursorSchema>;

// Opensearch's types are bugged. Null should be included but is not in the types
// https://github.com/opensearch-project/opensearch-js/issues/1051
const fieldValue = z
  .union([
    z.string(),
    z.number(),
    z.boolean(),
    z.undefined(),
    z.bigint(),
    z.null(),
  ])
  .transform((val) => val as string | number | boolean | undefined);

const OpensearchSearchAfterToken = z.array(fieldValue);

export const OpensearchPaginationCursorSchema = z.object({
  nextToken: OpensearchSearchAfterToken.optional(),
  previousToken: OpensearchSearchAfterToken.optional(),
  page: z.number(),
});
export type OpensearchPaginationCursor = z.infer<
  typeof OpensearchPaginationCursorSchema
>;
